import Vue from 'vue';
import Router from 'vue-router';
import LoginPage from '@/views/LoginPage';
import MyCars from '@/views/MyCars';
import Dashboard from '@/views/Dashboard';
import FindService from '@/views/FindService';
import UserProfile from '@/views/UserProfile';
import MyCar from '@/views/MyCar';
import MyVisits from '@/views/MyVisits';
import VisitsContainer from '~/VisitsContainer';
import PickCarService from '~/PickCarService';
import PickServiceStation from '~/PickServiceStation';
import PickVisitDate from '~/PickVisitDate';
import ConfirmVisit from '~/ConfirmVisit';
import Confirmed from '~/Confirmed';
import Regulations from '~/Regulations';

import { userService } from '@/services/user-service';

import trackPageview from '@/helpers/track-pageview';
import store from '@/vuex/store';

Vue.use(Router);

export const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'LoginPage',
      component: LoginPage,
    },
    {
      path: '/visit_cancellation/:access_token',
      name: 'VisitCancellation',
      component: LoginPage,
      meta: {
        noRedirection: true,
      },
    },
    {
      path: '/dashboard',
      name: 'Dashboard',
      component: Dashboard,
      meta: {
        requiresAuth: true,
      },
      children: [
        {
          path: 'mycars',
          name: 'MyCars',
          component: MyCars,
          meta: {
            requiresAuth: true,
          },
        },
        {
          path: 'map',
          name: 'FindService',
          component: FindService,
          meta: {
            requiresAuth: true,
          },
        },
        {
          path: 'profile',
          name: 'UserProfile',
          component: UserProfile,
          meta: {
            requiresAuth: true,
          },
        },
        {
          path: 'carinfo/:id',
          name: 'MyCar',
          component: MyCar,
          meta: {
            requiresAuth: true,
          },
        },
        {
          path: 'visits',
          name: 'Visits',
          component: MyVisits,
          meta: {
            requiresAuth: true,
          },
          children: [
            {
              path: 'next/:id',
              name: 'NextVisits',
              component: VisitsContainer,
              meta: {
                requiresAuth: true,
              },
            },
            {
              path: 'history/:id',
              name: 'HistoryVisits',
              component: VisitsContainer,
              meta: {
                requiresAuth: true,
              },
            },
            {
              path: 'new/:id/service',
              name: 'PickCarService',
              component: PickCarService,
              meta: {
                requiresAuth: true,
              },
            },
            {
              path: 'new/:id/station',
              name: 'PickServiceStation',
              component: PickServiceStation,
              meta: {
                requiresAuth: true,
              },
            },
            {
              path: 'new/:id/date',
              name: 'PickVisitDate',
              component: PickVisitDate,
              meta: {
                requiresAuth: true,
              },
            },
            {
              path: 'new/:id/confirm',
              name: 'ConfirmVisit',
              component: ConfirmVisit,
              meta: {
                requiresAuth: true,
              },
            },
            {
              path: 'new/:id/confirmed',
              name: 'ConfirmedVisit',
              component: Confirmed,
              meta: {
                requiresAuth: true,
              },
            },
            {
              path: 'edit/:id/service',
              name: 'EditCarService',
              component: PickCarService,
              meta: {
                requiresAuth: true,
              },
            },
            {
              path: 'edit/:id/station',
              name: 'EditServiceStation',
              component: PickServiceStation,
              meta: {
                requiresAuth: true,
              },
            },
            {
              path: 'edit/:id/date',
              name: 'EditVisitDate',
              component: PickVisitDate,
              meta: {
                requiresAuth: true,
              },
            },
            {
              path: 'edit/:id/confirm',
              name: 'EditConfirmVisit',
              component: ConfirmVisit,
              meta: {
                requiresAuth: true,
              },
            },
            {
              path: 'edit/:id/confirmed',
              name: 'EditConfirmedVisit',
              component: Confirmed,
              meta: {
                requiresAuth: true,
              },
            },
          ],
        },
      ],
    },
    {
      path: '/no_auth',
      name: 'NoAuthentication',
      component: Dashboard,
      children: [
        {
          path: 'regulations',
          component: Regulations,
          name: 'Regulations',
          meta: {
            noRedirection: true,
          },
        },
        {
          path: 'map',
          name: 'FindServiceNoAuth',
          component: FindService,
          meta: {
            noRedirection: true,
          },
        },
        {
          path: 'visit',
          name: 'MyVisitsNoAuth',
          component: MyVisits,
          children: [
            {
              path: 'service',
              name: 'PickCarServiceNoAuth',
              component: PickCarService,
            },
            {
              path: 'station',
              name: 'PickServiceStationNoAuth',
              component: PickServiceStation,
            },
            {
              path: 'date',
              name: 'PickVisitDateNoAuth',
              component: PickVisitDate,
            },
            {
              path: 'confirm',
              name: 'ConfirmVisitNoAuth',
              component: ConfirmVisit,
            },
            {
              path: 'confirmed',
              name: 'ConfirmedVisitNoAuth',
              component: Confirmed,
            },
          ],
        },
      ],
    },
    {
      path: '/change_password/:access_token',
      name: 'ChangePassword',
      component: LoginPage,
      meta: {
        noRedirection: true,
      },
    },
    {
      path: '/user_activation/:access_token',
      name: 'UserActivation',
      component: LoginPage,
      meta: {
        noRedirection: true,
      },
    },
    {
      path: '*',
      redirect: '/',
    },
  ],
});

// eslint-disable-next-line
router.beforeEach((to, from, next) => {
  const authRequired = to.meta.requiresAuth;
  const loggedIn = userService.retrieve();
  const dashboardPath = '/dashboard/mycars';

  if (!loggedIn) {
    store.commit('auth/logout');
  }

  if (authRequired && !loggedIn) {
    return next('/');
  }
  if (!authRequired && loggedIn && from.path === '/' && !to.meta.noRedirection) {
    return next(dashboardPath);
  }
  if (loggedIn && to.path === '/') {
    return next(dashboardPath);
  }

  next();
});

router.afterEach((to) => {
  const { name, path } = to;
  // always top after route change
  if (!path.includes('map')) {
    window.scrollTo(0, 0);
  }

  if (typeof ga === 'function') {
    trackPageview(name, path);
  }
});
